module.exports = __webpack_public_path__ + "static/media/emoticon-emoticons-emotion-expression-face-2-svgrepo-com.d0a7346c.svg";